const POI_MARKER_PATH =
  'https://static.spotahome.com/map/marker-point-of-interest.svg';

// `woosmap.map.Marker` keeps a default rounded-rectangle container behind the
// icon even when scaledSize+anchor are set, which shows up as a white box
// around the SVG pin. Render the POI through OverlayView instead for a plain
// <img> with no Woosmap chrome. Render the SVG at its native 76x71 (matches
// the Google + Mapbox arms) and anchor at the pin tip (38, 68 in the SVG's
// coord space) so the lat/lng sits at the bottom of the visible pin shape,
// before the drop-shadow padding.
const POI_ICON_WIDTH = 76;
const POI_ICON_HEIGHT = 71;
const POI_ICON_ANCHOR_X = 38;
const POI_ICON_ANCHOR_Y = 68;

export const POI_CIRCLE_COLOR = '#ffccef';

export const createPoiMarkerOverlay = position => {
  class PoiMarkerOverlay extends window.woosmap.map.OverlayView {
    constructor() {
      super();
      this.position = position;
      this.containerDiv = null;
    }

    onAdd() {
      this.containerDiv = document.createElement('div');
      this.containerDiv.style.position = 'absolute';
      const img = document.createElement('img');
      img.src = POI_MARKER_PATH;
      img.width = POI_ICON_WIDTH;
      img.height = POI_ICON_HEIGHT;
      img.style.display = 'block';
      this.containerDiv.appendChild(img);
      this.getPanes().overlayMouseTarget.appendChild(this.containerDiv);
    }

    draw() {
      if (!this.containerDiv) return;
      const projection = this.getProjection();
      if (!projection) return;
      const point = projection.fromLatLngToDivPixel(this.position);
      if (!point) return;
      this.containerDiv.style.left = `${point.x - POI_ICON_ANCHOR_X}px`;
      this.containerDiv.style.top = `${point.y - POI_ICON_ANCHOR_Y}px`;
    }

    onRemove() {
      if (this.containerDiv?.parentNode) {
        this.containerDiv.parentNode.removeChild(this.containerDiv);
      }
      this.containerDiv = null;
    }
  }

  return new PoiMarkerOverlay();
};
